import { createSvgIcon } from "@mui/material/utils";

export const LightBulb = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00004 14C6.00004 14.3667 6.30004 14.6667 6.66671 14.6667H9.33338C9.70004 14.6667 10 14.3667 10 14V13.3333H6.00004V14ZM8.00004 1.33334C5.42671 1.33334 3.33337 3.42668 3.33337 6.00001C3.33337 7.58668 4.12671 8.98001 5.33337 9.82668V11.3333C5.33337 11.7 5.63337 12 6.00004 12H10C10.3667 12 10.6667 11.7 10.6667 11.3333V9.82668C11.8734 8.98001 12.6667 7.58668 12.6667 6.00001C12.6667 3.42668 10.5734 1.33334 8.00004 1.33334ZM9.90004 8.73334L9.33338 9.13334V10.6667H6.66671V9.13334L6.10004 8.73334C5.20004 8.10668 4.66671 7.08668 4.66671 6.00001C4.66671 4.16001 6.16004 2.66668 8.00004 2.66668C9.84004 2.66668 11.3334 4.16001 11.3334 6.00001C11.3334 7.08668 10.8 8.10668 9.90004 8.73334Z"
      fill="#5048E5"
    />
  </svg>,
  "LightBulb"
);
